import reducer from "./reducer";
import { IResumeStore as store } from "./store";

export const resumeReducer = reducer;
export type IResumeStore = store;
